import React, { useState } from 'react';
import RobotaxiLogin from '../../Images/LoginImage.png';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import ValidationMessages from "../utils/validationMessages"; 

const ResetPassword = () => {
    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
    const navigate = useNavigate();
    const [loginUserData, setloginUserData] = useState({
        EmailId: '',
    });
    const [EmailForRestPassword, sendingEmailForRestPassword] = useState(false);
    const [errors, setErrors] = useState({});
    // const [formData, setFormData] = useState({
    //     Password: '',
    //     ConfirmPassword: '',
    // });
    const [isButtonDisabled, setIsButtonDisabled] = useState(false); // Add this line

    const handleButtonClick = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            let resetEmail = {
                EmailId: loginUserData.EmailId.trim().toLowerCase(),
                TypeOfEmail: "emailhasbeensend",
                DomainName: window.location.origin
            };
            try {
                const response = await axios.post(`${hostPath}/api/SendEmailConfirmation`, resetEmail, {
                    headers: { "x-functions-key":  `${hostHeader}`  }
                });
    
                if (response.data) {
                    console.log("response.data", response.data);
                    if(response.data.status === false){
                        setErrors({ ...errors, EmailId: response.data.responseMessage});

                    }
                    else{
                        sendingEmailForRestPassword(true);
                        setIsButtonDisabled(true); 
                    }
                } else {
                    setErrors({ ...errors, Password: ValidationMessages.correctPassword });
                }
            } catch (error) {
                console.error('Error:', error);
            }
        }
    };
    

    // const validatePasswordForm = () => {
    //     const errors = {};
    //     if (!formData.Password) {
    //         errors.Password = ValidationMessages.PasswordRequired;
    //     } else if (formData.Password.length < 8) { // Check if the length of the password is less than 8
    //         errors.Password = ValidationMessages.passwordConstraint;
    //     } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])/.test(formData.Password)) {
    //         errors.Password = ValidationMessages.passwordRequirements;
    //     }

    //     if (!formData.ConfirmPassword) {
    //         errors.ConfirmPassword = ValidationMessages.confirmPasswordRequired;
    //     } else if (formData.Password !== formData.ConfirmPassword) {
    //         errors.ConfirmPassword = ValidationMessages.newandconfirmPasswordShouldMatch;
    //     }

    //     setErrors(errors);
    //     return Object.keys(errors).length === 0;
    // };

    const validateForm = () => {
        const errors = {};
        if (!loginUserData.EmailId.trim()) {
            errors.EmailId = ValidationMessages.emailRequired;
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handleButtonClick1 = () => {
        navigate('/login');
    }

    const clearError = (fieldName) => {
        setErrors((prevErrors) => {
            return { ...prevErrors, [fieldName]: '' };
        });
    };

    return (
        <div className="container-fluid p-0">
            <div className="row m-0">
                <div className="col-md-7 p-0">
                    <img src={RobotaxiLogin} alt="Login" className="GeoparkingImage"  />
                </div>
                <div className="col-md-5 d-flex align-items-center justify-content-center">
                    <div className="login-form loginfirst">
                        <div className="login">
                            <h3 className='loginheader textleft'>Reset Your Password</h3>
                            {
                                EmailForRestPassword ?
                                    <p className="mb-4 loginDescription textleft">Check your email for a link to reset your password. If it doesn't appear within a few minutes, check your spam folder.</p> :
                                    <p className="mb-4 loginDescription textleft">Forgotten your password? Enter your registered email id to reset it now.</p>
                            }
                        </div>
                        {
                            EmailForRestPassword ? null :
                                <div className="otp-input mb-4">
                                    <div className="Username mb-4 textleft formbox">
                                        <label htmlFor="username" className='userName loginlabel'>Email</label><span className='mandatorymark loginlabel'>*</span>
                                        <input
                                            type="text"
                                            className={`form-control ${loginUserData.EmailId ? 'input-active' : ''}`}
                                            id="username"
                                            placeholder='Enter Email'
                                            value={loginUserData.EmailId}
                                            onChange={(e) => {
                                                clearError('EmailId');
                                                const trimmedEmail = e.target.value.trim();
                                                setloginUserData({ ...loginUserData, EmailId: trimmedEmail });
                                            }}
                                        />
                                        {errors.EmailId && <div className="error-message mandatorymark">{errors.EmailId}</div>}
                                    </div>
                                </div>
                        }
                        <div className="d-flex justify-content-between mb-5">
                            {
                                EmailForRestPassword ?
                                    <button type="button" className='forgotpasswordbutton' onClick={handleButtonClick1}>Return to sign in</button> :
                                    <button type="button" className='forgotpasswordbutton' onClick={handleButtonClick} disabled={isButtonDisabled}>Send password reset email</button>
                            }
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
